import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';
import { useExcursionFilterFormatTitle, locales as localesFormat } from '@/features/filter/format';
import { locales as localesDuration } from '@/features/filter/duration';
import { useExcursionFilterMovementTitle, locales as localesMovement } from '@/features/filter/movement-type';
import { useExcursionFilterPriceTitle, locales as localesPrice } from '@/features/filter/price';
import { locales as localesOutput } from '../../i18/index.ts';
import { mergeLocales } from '@/shared/lib/merge-locales';
import type { CurrencyCode } from '@/shared/lib/currency';
import { useExcursionAdditionalFilterOptions } from './useExcursionAdditionalFilterOptions.ts';

export function useExcursionFiltersTitles(currencyCode: CurrencyCode) {
  const locales = mergeLocales(localesDuration, localesFormat, localesMovement, localesPrice, localesOutput);

  const filtersStore = useExcursionFiltersStore();

  const { title: titleFormat, isActive: isActiveFormat } = useExcursionFilterFormatTitle(locales.ru);
  const { title: titlePrice, isActive: isActivePrice } = useExcursionFilterPriceTitle({
    messages: locales.ru,
    currencyCode,
  });
  const { title: titleMovement, isActive: isActiveMovement } = useExcursionFilterMovementTitle(locales.ru);
  const {
    isActiveDatesFilter,
    isActiveStartTimeIntervalFilter,
    isActiveDurationIntervalFilter,
    isActiveChildrenFilter,
    childrenTitle,
    dateTitle,
    startTimeIntervalTitle,
    durationIntervalTitle,
  } = useExcursionAdditionalFilterOptions(locales.ru);

  // TODO: пересмотреть после разделения сторов
  const resetters = {
    format: () => {
      filtersStore.reset('type');
      filtersStore.reset('tourFormat');
    },
    tourFormat: () => filtersStore.reset('tourFormat'),
    price: () => filtersStore.reset('price'),
    movement: () => filtersStore.reset('movementTypes'),
    date: () => filtersStore.reset('date'),
    children: () => filtersStore.reset('childrenAllowed'),
    startInterval: () => filtersStore.reset('startTimeInterval'),
    durationInterval: () => filtersStore.reset('durationInterval'),
  };

  // 🔹 ОДНА «комбинированная» активность формата
  const isActiveFormatChip = computed(() => isActiveFormat.value);

  // 🔹 Какой заголовок показывать для чипсы формата
  const formatTitleForChip = computed(() => {
    if (isActiveFormat.value) {
      return titleFormat.value;
    }
  });

  const filterChips = computed(() => {
    const options = [];

    if (isActiveDatesFilter.value) {
      options.push({
        value: 'date',
        label: dateTitle.value,
      });
    }

    if (isActiveFormatChip.value) {
      options.push({
        value: 'format',
        label: formatTitleForChip.value,
      });
    }

    if (isActiveChildrenFilter.value) {
      options.push({
        value: 'children',
        label: childrenTitle.value,
      });
    }

    if (isActiveDurationIntervalFilter.value) {
      options.push({
        value: 'durationInterval',
        label: durationIntervalTitle.value,
      });
    }

    if (isActiveStartTimeIntervalFilter.value) {
      options.push({
        value: 'startInterval',
        label: startTimeIntervalTitle.value,
      });
    }

    if (isActivePrice.value) {
      options.push({
        value: 'price',
        label: titlePrice.value,
      });
    }

    if (isActiveMovement.value) {
      options.push({
        value: 'movement',
        label: titleMovement.value,
      });
    }

    return options;
  });

  return {
    filterChips,
    resetters,
  };
}
